import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function initHeroAnimations() {
  if (prefersReducedMotion) {
    gsap.set(".hero-title__word", { y: 0 });
    gsap.set(".hero-cta", { opacity: 1, y: 0 });
    gsap.set(".hero__label", { opacity: 1 });
    gsap.set(".hero__scroll-indicator", { opacity: 1 });
    return;
  }

  const tl = gsap.timeline({ defaults: { ease: "expo.out" } });

  tl.to(".hero__label", {
    opacity: 1,
    duration: 0.8,
    delay: 0.3,
  })
    .to(
      ".hero-title__word",
      {
        y: 0,
        duration: 1.2,
        stagger: 0.15,
        ease: "expo.out",
      },
      "-=0.4"
    )
    .to(
      ".hero-cta",
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
      },
      "-=0.5"
    )
    .to(
      ".hero__scroll-indicator",
      {
        opacity: 0.6,
        duration: 1,
      },
      "-=0.3"
    );
}

export function initScrollAnimations() {
  if (prefersReducedMotion) return;

  const sections = gsap.utils.toArray(
    "#about, #projects, #contact"
  );

  sections.forEach((section) => {
    gsap.from(section, {
      scrollTrigger: {
        trigger: section,
        start: "top 85%",
        end: "top 50%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      scale: 0.95,
      y: 40,
      duration: 1,
      ease: "expo.out",
    });
  });

  gsap.utils.toArray(".section-title").forEach((title) => {
    gsap.from(title, {
      scrollTrigger: {
        trigger: title,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "expo.out",
    });
  });

  gsap.utils.toArray(".project-wrapper__text").forEach((card, i) => {
    gsap.from(card, {
      scrollTrigger: {
        trigger: card,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      x: -30,
      duration: 0.8,
      delay: i * 0.1,
      ease: "expo.out",
    });
  });

  gsap.utils.toArray(".project-wrapper__image").forEach((img, i) => {
    gsap.from(img, {
      scrollTrigger: {
        trigger: img,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      x: 30,
      duration: 0.8,
      delay: i * 0.1,
      ease: "expo.out",
    });
  });

  gsap.utils.toArray(".about-wrapper__image").forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      scale: 0.9,
      duration: 1,
      ease: "expo.out",
    });
  });

  gsap.utils.toArray(".about-wrapper__info").forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      x: 40,
      duration: 1,
      ease: "expo.out",
    });
  });

  const contactWrapper = document.querySelector(".contact-wrapper");
  if (contactWrapper) {
    gsap.from(contactWrapper, {
      scrollTrigger: {
        trigger: contactWrapper,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 40,
      duration: 1,
      ease: "expo.out",
    });
  }
}

export function initParallaxThumbnails() {
  if (prefersReducedMotion) return;

  gsap.utils.toArray(".terminal-mockup").forEach((mockup) => {
    gsap.to(mockup, {
      scrollTrigger: {
        trigger: mockup,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
      y: -20,
      ease: "none",
    });
  });
}

export function initTerminalReveal() {
  if (prefersReducedMotion) return;

  document.querySelectorAll(".terminal-mockup").forEach((mockup) => {
    const lines = mockup.querySelectorAll(".terminal-mockup__line");
    lines.forEach((line) => {
      line.style.animationPlayState = "paused";
    });

    ScrollTrigger.create({
      trigger: mockup,
      start: "top 80%",
      once: true,
      onEnter: () => {
        lines.forEach((line) => {
          line.style.animationPlayState = "running";
        });
      },
    });
  });
}

export function initNavScroll() {
  const nav = document.getElementById("nav");
  if (!nav) return;

  ScrollTrigger.create({
    start: 80,
    onUpdate: (self) => {
      if (self.scroll() > 80) {
        nav.classList.add("is-scrolled");
      } else {
        nav.classList.remove("is-scrolled");
      }
    },
  });
}
